'use client'

;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { usePrefersReducedMotion } from '@/lib/motion/reduced-motion'
import { clsx } from 'clsx/lite'
import { useEffect, useRef, useState, type ReactNode } from 'react'

import styles from './app-ui-visual.module.css'

export function AppUiVisual({
  children,
  className,
  label,
}: {
  children: ReactNode
  className?: string
  label: string
}) {
  const ref = useRef<HTMLDivElement>(null)
  const [inView, setInView] = useState(false)
  // Live, not read once at mount: switching reduced motion on stops a visual that is playing.
  const reducedMotion = usePrefersReducedMotion()
  const playing = inView && !reducedMotion

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting && entry.intersectionRatio >= 0.4),
      { threshold: [0, 0.4, 1] },
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <div
      ref={ref}
      data-app-ui-visual=""
      data-playing={playing ? 'true' : 'false'}
      role="img"
      aria-label={label}
      className={clsx(styles.root, 'h-full w-full', className)}
    >
      {children}
    </div>
  )
}
